import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { LoyaltyCurrency, LoyaltyProgram } from '@rd/types';
import { TransferConnectV2WrapperComponentDirective } from '../../transfer-connect-v2-wrapper.component';

@Component({
  selector: 'rd-tcv2-loyalty-programs-list-item-mobile-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2LoyaltyProgramsListItemMobileWrapperComponent extends TransferConnectV2WrapperComponentDirective {
  @HostBinding('class.rd-tcv2-loyalty-programs-list-item-mobile-wrapper')
  componentClass = true;

  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() loading: boolean;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  componentName = 'tcv2-loyalty-programs-list-item-mobile';
}
